import { createFeatureSelector, createSelector } from '@ngrx/store';

import { MessagesState, featureKey } from './messages.reducer';

const selectFeature = createFeatureSelector<MessagesState>(featureKey);

const selectUnreadMessagesCount$ = createSelector(selectFeature, ({ unreadMessagesCount }) => unreadMessagesCount);
const selectLastGetParticipantUnreadMessagesRequestTimestamp$ = createSelector(
  selectFeature,
  ({ lastGetParticipantUnreadMessagesRequestTimestamp }) => lastGetParticipantUnreadMessagesRequestTimestamp
);
const selectIsLoading$ = createSelector(selectFeature, ({ isLoading }) => isLoading);
const selectIsMessagesListPolling$ = createSelector(selectFeature, ({ isMessagesListPolling }) => isMessagesListPolling);
const selectSystemMessages$ = createSelector(selectFeature, ({ systemMessages }) => systemMessages);
const selectParticipantMessages$ = createSelector(selectFeature, ({ participantMessages }) => participantMessages);

export const fromMessages = {
  selectUnreadMessagesCount$,
  selectLastGetParticipantUnreadMessagesRequestTimestamp$,
  selectIsLoading$,
  selectIsMessagesListPolling$,
  selectSystemMessages$,
  selectParticipantMessages$,
};
